export interface FMFSizes {
	id: number
	name: string
    size: string,
    created_at: string;
    updated_at: string;
}
